import * as React from 'react';
import styled, { withTheme } from 'styled-components';
import { rem } from 'polished';
import {
  FlexRow,
  FlexColCenter,
  FlexRowCenter,
  FlexCol,
  FlexRowCenterVertical,
} from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { TextP } from '../../Defaults/Text';
import { IconImg } from '../../Defaults/Icon/IconImg';
import { prop } from '../../../utilities';
import { Popup } from '../General/Popup';
import { StoresInfoPopup } from './StoresInfoPopup';
import { getPackagesString } from '../selectors';

interface Props {
  onStock: number;
  onStockExternal: number;
  unit: string;
  bottomMargin?: boolean;
  justify?: string;
  withoutInfo?: boolean;
  availability?: any;
  withoutExactStockCount?: boolean;
  storesInfo: any;
  mobileNoExactCount?: boolean;
  moveLeft?: boolean;
  productPackages?: number;
  fontSize?: number;
  lessInfo?: boolean;
  isSpojMat?: boolean;
}

function StockInfo({
  onStock,
  onStockExternal,
  unit,
  bottomMargin = true,
  justify = 'initial',
  withoutInfo = false,
  lessInfo = false,
  isSpojMat = false,
  availability = null,
  withoutExactStockCount = true,
  storesInfo,
  mobileNoExactCount = false,
  moveLeft = false,
  productPackages,
  fontSize = 12,
}: Props) {
  const textAvailability = prop(availability, 'avail_uniqid');
  const availabilityOrderAvailable = prop(availability, 'order_available', '');
  const isOnStock = onStock === 0 ? onStockExternal > 0 : onStock > 0;
  const isOnStockInternalText =
    textAvailability !== null ? textAvailability : __('Skladom');
  const isOnStockExternalText = __('Externý sklad');
  const noStockText = __('Na dopyt');

  const stockTextInternal = isOnStock
    ? onStock > 0
      ? getPackagesString(onStock, unit)
      : `0 ${unit}`
    : '';

  const stockTextExternal = isOnStock
    ? onStockExternal > 0
      ? onStockExternal > 5
        ? `viac ako 5 ${unit}`
        : getPackagesString(onStockExternal, unit)
      : ''
    : '';

  const isAvailable =
    availabilityOrderAvailable === ''
      ? onStock > 0
        ? true
        : onStockExternal > 0
      : availabilityOrderAvailable;

  const hasStoresInfo = storesInfo
    ? storesInfo.find(
        s =>
          (s.store_id === 'ordered' ||
            s.store_id === 'incoming' ||
            s.store_id === 'internal' ||
            s.store_id === 'external') &&
          s.quantity > 0,
      )
    : false;

  const isOnStockExternal = onStockExternal > 0;
  const isOnStockInternal = onStock > 0;

  return (
    <StockCount
      fontSize={fontSize}
      justify={justify}
      bottomMargin={bottomMargin}
      available={isAvailable}
    >
      <Wrapper>
        {lessInfo ? (
          isAvailable ? (
            isOnStockInternal ? (
              <div>{isOnStockInternalText}</div>
            ) : (
              <div>{isOnStockExternalText}</div>
            )
          ) : (
            <div>{!isOnStock && noStockText}</div>
          )
        ) : (
          <InfoTextWrapper>
            <StockInfotext available={isOnStockInternal}>
              {isOnStock && isOnStockInternalText}
              {!withoutExactStockCount && isOnStock && (
                <CountSpan mobileNoExactCount={mobileNoExactCount}>
                  {stockTextInternal}
                </CountSpan>
              )}
            </StockInfotext>
            {isOnStockExternal && (
              <StockInfotext available={isOnStockExternal}>
                {isOnStockExternal && !isSpojMat && isOnStockExternalText}
                {!withoutExactStockCount && isOnStock && !isSpojMat && (
                  <CountSpan mobileNoExactCount={mobileNoExactCount}>
                    {stockTextExternal}
                  </CountSpan>
                )}
              </StockInfotext>
            )}

            <div>{!isOnStock && noStockText}</div>
          </InfoTextWrapper>
        )}

        {!withoutInfo && hasStoresInfo && (
          <StoresInfoPopup
            unit={unit}
            isAvailable={isAvailable}
            storesInfo={storesInfo}
            moveLeft={moveLeft}
          />
          // <IconImg
          //   width={20}
          //   height={20}
          //   marginLeft={10}
          //   alt="info-icon"
          //   src={isAvailable ? infoGreenSrc.toString() : infoRedSrc.toString()}
          // />
        )}
      </Wrapper>
      {productPackages
        ? unit === 'Mks' && (
            <Package>{`Balenie: ${getPackagesString(
              productPackages,
              unit,
            )}`}</Package>
          )
        : null}
    </StockCount>
  );
}

const InfoTextWrapper = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: flex-start;
  min-width: max-content;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

const StockInfotext = styled.div<{
  available: boolean;
}>`
  color: ${({ theme, available }) =>
    available
      ? theme.colors.stockCountAvailable
      : theme.colors.stockCountWarning};
`;

const StockCount = styled.span<{
  available: boolean;
  bottomMargin: boolean;
  justify: string;
  fontSize: number;
}>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: ${({ fontSize }) => rem(fontSize)};
  color: ${({ theme, available }) =>
    available
      ? theme.colors.stockCountAvailable
      : theme.colors.stockCountUnavailable};
  font-family: ${({ theme }) => theme.font.tertiary};
  line-height: ${rem(22)};
  width: 100%;
  text-align: left;
  justify-content: ${({ justify }) => justify};
  margin-bottom: ${({ bottomMargin }) => (bottomMargin ? rem(11) : 0)};
  white-space: normal;
`;

const CountSpan = styled.span<{ mobileNoExactCount: boolean }>`
  margin-left: ${rem(4)};

  ${({ theme, mobileNoExactCount }) => theme.mediab.s450`
    display: ${mobileNoExactCount ? 'none' : 'initial'};
  `}
`;

const Package = styled.span`
  width: 50%;
  text-align: right;
  color: ${({ theme }) => theme.colors.textPrimary};
  margin-left: auto;
`;

export { StockInfo };
